import React from "react";
import { observer } from "mobx-react-lite";
import { useApp } from "../context";

import { tsParticles } from "tsparticles";

export const AnimatedBackground = observer(function AnimatedBackground() {
  const app = useApp();
  const ref = React.useRef<HTMLCanvasElement>(null);
  const vanta = React.useRef<any>(null);

  React.useLayoutEffect(() => {
    const interactivity = false;

    tsParticles
      .load("particles", {
        particles: {
          number: {
            value: 80,
            density: {
              enable: true,
              value_area: 800,
            },
          },
          color: {
            value: "#ccc",
          },
          shape: {
            type: "circle",
            stroke: {
              width: 0,
              color: "#ccc",
            },
            polygon: {
              nb_sides: 5,
            },
            image: {
              src: "img/github.svg",
              width: 100,
              height: 100,
            },
          },
          opacity: {
            value: 0.3,
            random: false,
            anim: {
              enable: false,
              speed: 1,
              opacity_min: 0.1,
              sync: false,
            },
          },
          size: {
            value: 2,
            random: true,
            anim: {
              enable: false,
              speed: 40,
              size_min: 0.1,
              sync: false,
            },
          },
          line_linked: {
            enable: true,
            distance: 150,
            color: "#ccc",
            opacity: 0.4,
            width: 1,
          },
          move: {
            enable: true,
            speed: 1,
            direction: "none",
            random: false,
            straight: false,
            out_mode: "out",
            bounce: false,
            attract: {
              enable: false,
              rotateX: 600,
              rotateY: 1200,
            },
          },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: {
              enable: interactivity,
              mode: "repulse",
            },
            onclick: {
              enable: interactivity,
              mode: "push",
            },
            resize: true,
          },
          modes: {
            grab: {
              distance: 400,
              line_linked: {
                opacity: 1,
              },
            },
            bubble: {
              distance: 400,
              size: 40,
              duration: 2,
              opacity: 8,
              speed: 3,
            },
            repulse: {
              distance: 200,
              duration: 0.4,
            },
            push: {
              particles_nb: 4,
            },
            remove: {
              particles_nb: 2,
            },
          },
        },
        retina_detect: true,
      })
      .then((particles) => {
        if (particles) {
          particles.play();
        }
      });
  }, [ref.current]);

  return <div id="particles" ref={ref} />;
});
